import type { SVGProps } from 'react'
const SvgSyChevronUpSystem = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="m23.1 16.6-2 2L12 9.5l-9.1 9-2-2L12 5.5z" />
	</svg>
)
export default SvgSyChevronUpSystem
